import { Injectable } from '@angular/core';
import { Observable, from, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { API } from 'aws-amplify';


export interface ApiMessageResponse {
    isComplete: boolean;
    data: string[];
}

export interface AddImageRequest {
    key: string;
    fileName: string;
    content: string;
    tagId: number;
    isDefault: boolean;
}

export interface ApiImageResponse {
    id: number;
    key?: string;
    fileName: string;
    content: string;
    tagId: number;
    uploadDate: string;
    sizeInKb?: number;
}

export interface ImageAssetResponse {
    id: number;
    key: string;
    fileName: string;
    content: string;
    tagId: number;
    uploadDate: string;
    sizeInKb?: number;
    isDefault?: boolean;
}

export interface ImageTagResponse {
    id: number;
    name: string;
    tagKey: string;
    imageId: number;
}



@Injectable({
    providedIn: 'root'
})
export class ImageLibraryService {

    public fetchImages(): Observable<ImageAssetResponse[]> {
        return from(API.get('portal', 'house-events/images', {})).pipe(
            catchError((error) => throwError(() => error))
        );
    }

    uploadImage(payload: AddImageRequest): Observable<ApiMessageResponse> {
        return from(API.post('portal', `images`, { body: payload })).pipe(
            catchError((error) => throwError(() => error))
        );
    }

    deleteImage(id: number): Observable<ApiMessageResponse> {

        return from(API.del('portal', `images?id=${id}`, {})).pipe(
            catchError((error) => throwError(() => error))
        );
    }


    updateDefault(id: number): Observable<ApiMessageResponse> {
        const data = {
            isDefault: true
        };
        return from(API.put('portal', `images?id=${id}`, { body: data })).pipe(
            catchError((error) => throwError(() => error))
        );
    }

    public getHouseEventTags(): Observable<ImageTagResponse[]> {
        return from(API.get('portal', 'house-events/tags', {})).pipe(
            catchError((error) => throwError(() => error))
        );
    }

}